<template>
    <div v-if="groupInstances.length > 0 || isEditingSchema || isNew">
        <div class="d-flex align-items-start">
            <h4>
                {{ groupSchema.Name }}
            </h4>
            <pc-help-icon v-on:click="showHelpText = !showHelpText" />
        </div>
        <pc-alert
            v-model:shown="showHelpText"
            dismissible>
            <channel-help
                v-bind:svg-name="groupSchema.SvgName"
                v-bind:help-text="groupSchema.HelpText" />
        </pc-alert>
        <div class="vgap-3 w-100">
            <channel-group
                v-for="(groupInstance, index) in groupInstances"
                v-bind:key="groupInstance.PublicId"
                v-bind:index="index"
                v-bind:group-instance="groupInstance"
                v-bind:group-schema="groupSchema" />
            <div>
                <pc-button
                    v-if="canAddGroupInstance"
                    class="mb-3"
                    v-on:click="addNewGroupInstance(groupSchema)">
                    Add {{ groupSchema.InstancePrefix }}
                </pc-button>
            </div>
        </div>
    </div>
</template>

<script setup>
    import { computed, inject, ref } from "vue";
    import { storeToRefs } from "pinia";
    import { PAGE_APP_SYMBOL } from "_Main/injectionSymbols";
    import channelGroup from "./channelGroup.vue";
    import channelHelp from "./channelHelp.vue";
    import { useChannelStore } from "./channelStore.js";

    const app = inject(PAGE_APP_SYMBOL);
    const channelStore = useChannelStore();
    const { channelInUse, isEditingSchema, isNew } = storeToRefs(channelStore);
    const { getGroupsBySchemaId, addGroup } = channelStore;

    const props = defineProps({
        groupSchema: { type: Object, required: true }
    });

    const showHelpText = ref(false);

    const groupInstances = computed(() => getGroupsBySchemaId(props.groupSchema.SchemaId));

    const canAddGroupInstance = computed(() => {
        if (!props.groupSchema.IsMultiInstance) {
            return false;
        }
        if (isEditingSchema.value && props.groupSchema.CanAddFieldsToExistingSchema) {
            return true;
        }
        return !channelInUse.value;
    });

    function addNewGroupInstance() {
        app.setUnsavedChanges(true);
        addGroup(props.groupSchema);
    }
</script>
